import { render, staticRenderFns } from "./AppSingleMultiSelect.vue?vue&type=template&id=f5a874b2"
import script from "./AppSingleMultiSelect.vue?vue&type=script&lang=js"
export * from "./AppSingleMultiSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports